var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ori-side-banner" }, [
    _c("div", { staticClass: "content-box" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._m(0),
          _c(
            "ul",
            { staticClass: "article-list" },
            _vm._l(_vm.platformNotices, function (item, index) {
              return _c(
                "li",
                {
                  key: item.id,
                  staticClass: "link",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "studentNotices",
                        query: {
                          uuid: item.id,
                        },
                      })
                    },
                  },
                },
                [
                  index < 2
                    ? _c(
                        "el-badge",
                        {
                          staticStyle: { "max-width": "98%" },
                          attrs: { value: "new" },
                        },
                        [
                          _c("span", { staticClass: "notice-tit" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]
                      )
                    : _c("span", { staticClass: "notice-tit" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                ],
                1
              )
            }),
            0
          ),
          _vm.platformNotices.length == 0
            ? _c("ComponentEmpty", {
                staticStyle: { padding: "0" },
                attrs: {
                  imgClass: "empty-img-size100",
                  title: "暂无公告通知",
                  tips: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "title mab20" }, [
      _c("i", { staticClass: "icon icon1" }),
      _vm._v("通知公告"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }